import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { MDBDataTable, MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";

import axios from "axios";
import { baseUrl } from "../../Store/Apis/BaseUrl";

// Components
import BaseComponent from "../BaseComponent";
import PaymentRow from "./PaymentRow";
// Actions
import * as caseActions from "../../Store/Actions/caseActions";

function mapStateToProps(store) {
  return {
    cases: store.cases,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    caseActions: bindActionCreators(caseActions, dispatch),
  };
}

class CombinedCasesComponent extends React.Component {
  state = {
    loading: false,
    sites: [],
    paymentsRows: [
      {
        siteId: null,
        paymentDate: null,
        NoOfPatients: 5555,
        amount: 5555,
        active: 1,
        // actions: null,
      },
    ],
  };

  componentDidMount() {
    this.getPaymentInfo();
    const fetchData = async () => {
      const res = await axios.get(`${baseUrl}/sites`);
      const { success, sites } = res.data;
      if (success) {
        this.setState({
          loading: false,
          sites: sites,
        });
        console.log("sites:", sites);
      } else {
        console.log("Error Getting Payments ");
      }
    };

    fetchData();
  }

  getPaymentInfo = async () => {
    const { paymentId } = this.props.match.params;
    let url = `${baseUrl}/payments/${paymentId}`;
    const res = await axios.get(url);

    const { success, payment } = res.data;
    let newPaymentRow = [];
    if (success) {
      console.log("payment", payment);
      newPaymentRow = [
        {
          siteId: null,
          paymentDate: null,
          NoOfPatients: payment.NoOfPatients,
          amount: payment.amount,
          active: 1,
        },
      ];
    }
    this.setState({
      paymentsRows: newPaymentRow,
    });
    console.log("SITES ARER:", newPaymentRow);
  };

  submit = async () => {
    const { paymentId } = this.props.match.params;

    const firstRowPayment = this.state.paymentsRows[0];
    console.log(firstRowPayment);
    // return;
    const res = await axios.post(`${baseUrl}/payments/${paymentId}`, {
      ...firstRowPayment,
    });
    const { success, payment } = res.data;
    if (success) {
      window.location.replace("/payments");
    }
  };

  changeSite = (index, value) => {
    let payment_rows = this.state.paymentsRows;
    payment_rows[index].siteId = value;
    this.setState({
      paymentsRows: payment_rows,
    });
  };
  changeDate = (index, value) => {
    let payment_rows = this.state.paymentsRows;
    payment_rows[index].paymentDate = value;
    this.setState({
      paymentsRows: payment_rows,
    });
  };
  changeNoOfPatients = (index, value) => {
    let payment_rows = this.state.paymentsRows;
    payment_rows[index].NoOfPatients = value;
    this.setState({
      paymentsRows: payment_rows,
    });
  };
  changeAmount = (index, value) => {
    let payment_rows = this.state.paymentsRows;
    payment_rows[index].amount = value;
    this.setState({
      paymentsRows: payment_rows,
    });
  };

  render() {
    let { paymentsRows, loading, sites } = this.state;

    return (
      <>
        <BaseComponent>
          <header className="panel-heading">
            <h6 className="panel-title-small"> Edit Payments</h6>
          </header>

          <div className="row">
            <div className="col-md-12 filter-tab">
              <div className="row">
                <div className="col-md-12">
                  <h3 className="table-title"> Payments</h3>
                </div>
              </div>
            </div>
            <div className="col-md-12 payments-table">
              <MDBTable bordered>
                <MDBTableHead>
                  <tr>
                    <th>Site</th>
                    <th>Date</th>
                    <th># of Patients</th>
                    <th>Amount</th>
                    {/* <th>Actions</th> */}
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {paymentsRows.map((row, index) => {
                    return (
                      <PaymentRow
                        paymentsRows={paymentsRows}
                        key={index}
                        row={row}
                        index={index}
                        sites={sites}
                        changeSite={this.changeSite}
                        changeDate={this.changeDate}
                        changeNoOfPatients={this.changeNoOfPatients}
                        changeAmount={this.changeAmount}
                      />
                    );
                  })}
                </MDBTableBody>
              </MDBTable>
            </div>
            <div className="col-md-10 "></div>
            {/* <div className="col-md-2 ">
              {" "}
              <p className="add-new-payment" onClick={this.addNewRow}>
                {" "}
                + Add New Line{" "}
              </p>
            </div> */}
            <div className="col-md-10 "></div>
            <div className="col-md-2  ">
              <button
                className="btn btn-success submit-btn"
                onClick={this.submit}
              >
                Submit
              </button>
            </div>
          </div>
        </BaseComponent>
      </>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CombinedCasesComponent);

// export default CombinedCasesComponent;
